<section class="flex flex-column consult__section">
  <div class="inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label class="field__label no-margin">{{screen.labels.therapy.heading}}</label>
    </h2>
    <span class="consult__section-help"></span>
  </div>

  <div class="col-12 px-0 py-0">
    <p-table [value]="therapies" class="col-12 p-0">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col [style.width.px]="85">
          <col [style.width.px]="120">
          <col>
          <col>
          <col [style.width.px]="180">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th colspan="2"></th>
          <th>{{screen.labels.therapy.diagnostic}}</th>
          <th>{{screen.labels.therapy.procedure}}</th>
          <th>{{screen.labels.therapy.doctor}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-idx="rowIndex">
        <ng-template [ngTemplateOutlet]="currentTherapy" *ngIf="value && idx === 0"></ng-template>
        <tr class="p-datatable__vertical-top p-datatable__top-width">
          <td><b>{{screen.labels.therapy.sesion}}</b></td>
          <td>{{item.idx}}</td>
          <td rowspan="2">{{item.diagnostic}}</td>
          <td rowspan="2">{{item.procedure}}</td>
          <td rowspan="2">{{item.turnDoctorName}}</td>
        </tr>
        <tr class="p-datatable__vertical-top">
          <td><b>{{screen.labels.therapy.date}}</b></td>
          <td>{{item.turnDate | date : 'dd-MM-yyyy' : '+0000'}}</td>
        </tr>
        <tr class="p-datatable__vertical-top">
          <td colspan="2"><b>{{screen.labels.therapy.prescription}}</b></td>
          <td colspan="3">{{item.prescription}}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <ng-template [ngTemplateOutlet]="currentTherapy" *ngIf="value"></ng-template>
      </ng-template>
    </p-table>

    <ng-template #currentTherapy>
      <tr class="p-datatable__vertical-top">
        <td><b>{{screen.labels.therapy.sesion}}</b></td>
        <td>{{therapies.length + 1}}</td>
        <td>
          <textarea pInputTextarea name="therapy-diagnostic__{{turn}}" [(ngModel)]="value.diagnostic" [rows]="4"
            validation [readonly]="readonly" class="uppercase no-margin"></textarea>
        </td>
        <td>
          <textarea pInputTextarea name="therapy-procedure__{{turn}}" [(ngModel)]="value.procedure" [rows]="4"
            validation [readonly]="readonly" class="uppercase no-margin"></textarea>
        </td>
        <td>{{value.turnDoctorName}}</td>
      </tr>
      <tr class="p-datatable__vertical-top">
        <td colspan="2"><b>{{screen.labels.therapy.prescription}}</b></td>
        <td colspan="3">
          <textarea pInputTextarea name="therapy-prescription__{{turn}}" [(ngModel)]="value.prescription" [rows]="3"
            validation [readonly]="readonly" class="uppercase no-margin"></textarea>
        </td>
      </tr>
    </ng-template>
  </div>

</section>